module.exports = __webpack_public_path__ + "img/kongapp-name-removebg.585cac15.png";